import { apiCall } from "./api";

const cache = new Map();

export const translateDocumentBatch = async (texts, language, documentType = "manual") => {
  if (language === "fr" || !texts.length) return texts;
  const key = `${language}:${documentType}:${JSON.stringify(texts)}`;
  if (cache.has(key)) return cache.get(key);
  const request = apiCall("/translations/documents", { method: "POST", data: { texts, language, document_type: documentType } })
    .then((result) => result.translations || texts)
    .catch(() => texts);
  cache.set(key, request);
  return request;
};